export default "__VITE_ASSET__d7664868__"